export default function MobileViewError() {
  return (
    <div className='mobile-view-error'>
      <h5>Mobile View is not Availabe for this website</h5>
    </div>
  );
}
